var _rect, _path, _path2, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 56,
    height: 56,
    fill: "#D8D8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 3.9C14.7114 3.9 3.9 14.7114 3.9 28C3.9 41.2886 14.7114 52.1 28 52.1C41.2897 52.1 52.1 41.2886 52.1 28C52.1 14.7114 41.2897 3.9 28 3.9ZM28 49.813C15.9718 49.813 6.18696 40.0282 6.18696 28C6.18696 15.9718 15.9718 6.18696 28 6.18696C40.0272 6.18696 49.813 15.9718 49.813 28C49.813 40.0282 40.0272 49.813 28 49.813Z",
    fill: "#FF4F00",
    stroke: "#FF4F00",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2429 34.0235L38.2429 34.0236C35.6515 36.9187 31.9179 38.5783 27.9997 38.5783C24.0804 38.5783 20.3478 36.9177 17.7565 34.0236L17.7564 34.0235C17.3357 33.5526 17.3756 32.8301 17.8455 32.4092C18.063 32.2134 18.3376 32.1174 18.6084 32.1174C18.9213 32.1174 19.2349 32.2454 19.4603 32.4983L38.2429 34.0235ZM38.2429 34.0235C38.6636 33.5525 38.6237 32.8299 38.1537 32.409C37.6825 31.987 36.9598 32.0283 36.5391 32.4982L36.539 32.4982M38.2429 34.0235L36.539 32.4982M36.539 32.4982C34.3816 34.9091 31.269 36.2913 27.9997 36.2913M36.539 32.4982L27.9997 36.2913M27.9997 36.2913C24.7304 36.2913 21.6179 34.9091 19.4604 32.4984L27.9997 36.2913Z",
    fill: "#FF4F00",
    stroke: "#FF4F00",
    strokeWidth: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 23.5,
    r: 2.5,
    fill: "#FF4F00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 23.5,
    r: 2.5,
    fill: "#FF4F00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.b339636803829f1c7d9ff4cc6233dfe7.svg";
export { ForwardRef as ReactComponent };